import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { Stack } from '../../../../Stack';
import { getPropsBlocker } from '../../../../../utils';

var contentBodyRootStyle = function contentBodyRootStyle(_ref) {
  var HeaderNavigationMenuContentBody = _ref.theme.componentOverrides.HeaderNavigationMenuContentBody;
  return HeaderNavigationMenuContentBody.Root.base;
};

export var HeaderNavigationMenuContentBodyRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    max-height: 400px;\n    overflow-y: auto;\n\n    ", "\n"])), contentBodyRootStyle);

var contentBodyOptionsRootStyle = function contentBodyOptionsRootStyle(_ref2) {
  var HeaderNavigationMenuContent = _ref2.theme.componentOverrides.HeaderNavigationMenuContent;
  return HeaderNavigationMenuContent.BodyOptionsRoot.base;
};

export var HeaderNavigationMenuContentBodyOptionsRoot = styled(Stack).withConfig(getPropsBlocker({}, false))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n"])), contentBodyOptionsRootStyle);